export const PLURAL_KEY = "plural";
export const SINGLE_KEY = "single";
